import { configConstants, status } from "../_constants";

let initialState = {};

export function config(state = initialState, action) {
  switch (action.type) {
    case configConstants.CONFIG_REQUEST:
      return {
        ...state,
        config_status: status.IN_PROGRESS,
        config_data: null,
      };
    case configConstants.CONFIG_SUCCESS:
      return {
        ...state,
        config_status: status.SUCCESS,
        config_data: action?.data,
      };
    case configConstants.CONFIG_FAILURE:
      return {
        ...state,
        config_status: status.FAILURE,
        config_data: action?.data,
      };

    default:
      return state;
  }
}
